module.exports = __webpack_public_path__ + "img/model1_ug.7d32e8ad.png";